import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { useRunDataExtractMutation } from '@/react-query/mutations/attributions'

import { type SchemaType, schema } from './RunDataExtractForm.schema'

export interface RunDataExtractFormProps extends Omit<UseFormProps<SchemaType>, 'resolver'> {
  children?: ((form: UseFormReturn<SchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<SchemaType>
}

export const RunDataExtractForm: React.FC<RunDataExtractFormProps> = ({
  children,
  onSubmit,
  ...props
}) => {
  const form = useFormWithSchema({ mode: 'all', ...props }, schema)

  const runDataExtractMutation = useRunDataExtractMutation(form.getValues('input_type'))

  const submit = form.handleSubmit(
    onSubmit ??
      (async (_data, _e) => {
        await runDataExtractMutation.mutateAsync({ value_date: _data.report_date })
        form.reset()
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
